// src/config.js
// Game configuration - fetched from backend, with fallback defaults
import {reactive} from 'vue'
import apiClient from './api'

// Default config (used as fallback if backend is unreachable)
const DEFAULT_CONFIG = {
  INITIAL_TIME: 60,
  CORRECT_ANSWER_BONUS: 10,
  HINT_TIMEOUT: 6,
  MAX_TIME_CAP: 180,
  PASS_PENALTY: 3,
  WRONG_ANSWER_PENALTIES: [1, 2, 3],
  MAX_PASSES: 3,
  MAX_WRONG_ANSWERS: 3,
  MAX_CORRECT_ANSWERS: 20,
  SCORING: {
    EASY: 1191,
    MEDIUM: 2382,
    HARD: 3573,
    TIME_BONUS_PER_SECOND: 2,
    TIME_BONUS_CAP: 15,
    STREAK_BONUS_STEP: 0.05,
    MAX_STREAK_BONUS: 0.50
  }
}

// Reactive config that can be updated after fetching from backend
export const GAME_CONFIG = reactive({ ...DEFAULT_CONFIG })

// Track if config has been loaded
let configLoaded = false

// Fetch config from backend
export async function loadGameConfig() {
  if (configLoaded) return GAME_CONFIG

  try {
    const response = await apiClient.get('/game/config/')
    Object.assign(GAME_CONFIG, response.data)
    configLoaded = true
  } catch (error) {
    console.warn('Failed to fetch game config from backend, using defaults:', error.message)
  }

  return GAME_CONFIG
}

// Check if config has been loaded
export function isConfigLoaded() {
  return configLoaded
}
